
/**
 *
 * @param {string|number} amount
 * @param {float|number|string} apr
 * @param {number|string} term
 * @param {string} frequency weekly ,fortnightly, or monthly
 * @returns string
 *
 * @see https://www.kasasa.com/blog/how-to-calculate-loan-payments-in-3-easy-steps
 * P = A {r(1+r)^n} / {(1+r)^n –1}
 */
export function calculate( amount, apr, term, frequency ) {
	if ( typeof amount === 'string' ) {
		amount = parseFloat( amount.replace(/[^0-9\.]+/g, '' ) );
	}

	let payments = 0;
	let rate = 0;
	let payment = 0;

	switch ( frequency ) {
		case 'weekly':
			payments = term * 52;
			rate = apr / 52 / 100;
		break;
		case 'fortnightly':
			payments = term * 26;
			rate = apr / 26 / 100;
		break;
		case 'monthly':
		default:
			payments = term * 12;
			rate = apr / 12 / 100;
		break;
	}

	if ( rate > 0 ) {
		payment = amount * ( ( rate * ( Math.pow( 1 + rate, payments ) ) ) / ( Math.pow( 1 + rate, payments ) - 1 ) );
	} else {
		payment = amount / payments;
	}

	return formatCurrency( payment, 2 );
}

export function formatCurrency( num, digits = 2 ) {
	if ( typeof num === 'string' ) {
		num = num.replace( /[^0-9\.]+/g, '' );
	}

	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: digits,
		maximumFractionDigits: digits,
	} );

	return formatter.format( num );
}

export function sanitizeNumeric( num ) {
	const type = typeof num;

	if ( type === 'number' && isNaN( type ) ) {
		return '';
	}

	if ( 'string' === type ) {
		return num.replace(/[^0-9\.,]*/g, '');
	}

	return num;
}
